<template>
  <transition-group
    enter-active-class="ease-in-out duration-300"
    enter-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="ease-in-out duration-300"
    leave-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-show="active"
      @click="$emit('close')"
      class="fixed inset-0 z-40 bg-black bg-opacity-50 transition-opacity"
      :key="1"
    ></div>
    <div
      v-show="active"
      :key="2"
      class="fixed inset-y-0 right-0 z-50 flex max-w-full transform transition duration-500 ease-in-out"
    >
      <transition
        enter-active-class="transform transition ease-in-out duration-500 sm:duration-700"
        enter-class="translate-x-full"
        enter-to-class="translate-x-0"
        leave-active-class="transform transition ease-in-out duration-500 sm:duration-700"
        leave-class="translate-x-0"
        leave-to-class="translate-x-full"
      >
        <slot />
      </transition>
    </div>
  </transition-group>
</template>

<script>
export default {
  props: { active: { type: Boolean, default: false } },
};
</script>

<style></style>
